import { AriaFormatter } from '../../types';

export const defaultItemAriaLabelFormatter: AriaFormatter = (slideIndex) =>
  `Перейти к слайду ${slideIndex + 1}`;
